/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setInstagramSlider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
let sbiLoad = document.querySelectorAll('#sbi_load');
if (sbiLoad) {
    let sbi_images = document.querySelectorAll('#sbi_images');
    sbi_images.forEach(function (sbi_item) {
        let sbi_items = sbi_item.querySelectorAll('.sbi_item');
        let id_elements = [];

        for (let i = 0; i < sbi_items.length; i++) {
            id_elements.push(sbi_items[i].getAttribute('id'));
            let sbi_item_clone = sbi_items[i].cloneNode(sbi_items[i]);
            if (sbi_item_clone.getAttribute('id') == id_elements[i]) {
                id_elements[i] = id_elements[i] + '_clone';
                sbi_item_clone.id = id_elements[i];
                sbi_item.appendChild(sbi_item_clone);
            }
        }
    });
}